import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withSellers } from 'containers/ContactsList';
import VendorSettingsCard from 'routes/Store/components/StoreCard';

class VendorSettingsContainer extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    history: PropTypes.shape({
      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.WrappedVendorSettingsCard = withSellers(VendorSettingsCard, true);
  }

  render() {
    const { WrappedVendorSettingsCard } = this;
    const { history } = this.props;
    const { isFarmer, isRestaurant } = this.context;

    return (
      <div className="store-page">
        <WrappedVendorSettingsCard
          helper="vendor-settings"
          isFarm={isFarmer}
          isRest={isRestaurant}
          label={['A-Z']}
          location={history.location}
          push={history.push}
          title="Availability"
          type="stores"
          isVendor
        />
      </div>
    );
  }
}

const mapStateToProps = (/* state */) => ({
});

export default connect(mapStateToProps)(VendorSettingsContainer);
